module.exports = __webpack_public_path__ + "img/exchange-line.be1846a1.svg";